import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { FaQuestionCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import apiClient from "../../api/apiClient";
import useApi from "../../hooks/useApi";

export default () => {
  const [reqType, setReqType] = useState("Request Type");
  const [requests, setRequest] = useState();

  const handleChange = (key, value) => {
    if (key !== "message") {
      setReqType(`${key}`);
    } else {
      const message = document.getElementById("message");
      const listener = (e) => {
        setRequest({
          ...requests,
          message: e.target.value,
        });
      };
      message.addEventListener("input", listener);
      return () => message.removeEventListener("input", listener);
    }
  };

  const { request, loading, error } = useApi((resultData) =>
    apiClient.post("/photographerRequest", resultData)
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    const resultData = {
      request_type: reqType,
      message: requests.message,
    };
    const result = await request(resultData);
    if (result.status === 200) {
      toast.success("Account Succesfully Created");
    } else {
      toast.error("Error");
    }
  };

  const photoRequests = [
    {
      id: 1,
      dateTime: "12/15/2022; 1:00pm",
      location: "Sofi Stadium, Inglewood,",
      earnings: "$450.00",
      buttonText: "PhotoShoot",
      image: require("../../assets/img/cameraGray.png"),
      imageSrc: require("../../assets/img/calendar.png"),
    },

    {
      id: 2,
      dateTime: "12/16/2022; 2:00pm",
      location: "Madison Square Garden,",
      earnings: "$600.00",
      buttonText: "VideoShoot",
      image: require("../../assets/img/videoGray.png"),
      imageSrc: require("../../assets/img/calendar.png"),
    },
    {
      id: 3,
      dateTime: "12/16/2022; 2:00pm",
      location: "Madison Square Garden,",
      earnings: "$600.00",
      buttonText: "Drone",
      image: require("../../assets/img/droneGray.png"),
      imageSrc: require("../../assets/img/calendar.png"),
    },
  ];

  return (
    <div>
      <div className="site-content h-100">
        <div className="p-4">
          <div className="site-content-body">
            <div className="position-relative">
              {/*-----------------------------
                  Start || Payment section
                   ----------------------------- */}
              <section className="req-sec main-sec border py-3">
                <div className="container">
                  <form onSubmit={handleSubmit}>
                    {/* ----------Request textarea--------- */}
                    <div className="d-md-flex make_res justify-content-between mt-3">
                      <div className="req-field d-sm-flex w-100">
                        <div className="req-btn px-2">
                          <div className="dropdown">
                            <button
                              className="btn btn-secondary shadow-none dropdown-toggle text-secondary"
                              type="button"
                              id="dropdownMenuButton1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              {reqType}
                            </button>
                            <ul
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li
                                onClick={() =>
                                  handleChange("PhotoShoot", "photoshoot")
                                }
                              >
                                <a className="dropdown-item  ms-1 " href="#">
                                  <i className="bi bi-camera-fill me-1" />
                                  Photoshoot
                                </a>
                              </li>
                              <li
                                onClick={() =>
                                  handleChange("Videoshoot", "videoshoot")
                                }
                              >
                                <a className="dropdown-item  ms-1 " href="#">
                                  <img
                                    src={require("../../assets/img/video.png")}
                                    alt=""
                                    className="img-fluid me-1"
                                    width={20}
                                  />
                                  Videoshoot
                                </a>
                              </li>
                              <li
                                onClick={() => handleChange("Drone", "drone")}
                              >
                                <a className="dropdown-item  ms-1 " href="#">
                                  <img
                                    src={require("../../assets/img/drone-dark.png")}
                                    alt=""
                                    className="img-fluid me-1"
                                    width={20}
                                  />
                                  Drone
                                </a>
                              </li>
                              <li
                                onClick={() => handleChange("Other", "others")}
                              >
                                <a className="dropdown-item  ms-1 " href="#">
                                  <img
                                    src={require("../../assets/img/question.png")}
                                    alt=""
                                    width={20}
                                    className="img-fluid me-1"
                                  />
                                  Other...
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <textarea
                          name
                          onChange={(e) =>
                            handleChange("message", e.target.value)
                          }
                          id="message"
                          className="py-1 d-block blue-txt w-100 bg-white"
                          placeholder="Type your message to Rolling Adz here..."
                        />
                      </div>
                      <div className="ms-2 d-flex justify-content-end req-btns mt-3 mt-md-0 pad">
                        <a
                          href="#"
                          type="submit"
                          className="d-flex align-items-center px-3 blue-txt bg-white text-center"
                        >
                          Send
                        </a>
                        <a
                          href="#"
                          className="d-flex align-items-center px-3 blue-txt bg-white text-center"
                        >
                          Delete
                        </a>
                      </div>
                    </div>
                    <div className="my-hr my-3 mx-auto" />
                    {/* ----------Request view--------- */}
                    {photoRequests.map((request, index) => (
                      <div className=" d-md-flex make_res  mt-3">
                        <div
                          className="  req-field d-sm-flex w-100"
                          key={index}
                        >
                          <div className="req-btn d-flex align-items-center ps-2  grey-txt">
                            <img
                              src={request.image}
                              alt=""
                              width="20px"
                              className="img-fluid me-1"
                            />
                            <button className="py-3 grey-txt">
                              {request.buttonText}
                            </button>
                          </div>
                          <div className=" d-flex px-1 align-items-center blue-txt w-100 bg-white req-fix">
                            <div className="pe-2  position-relative req-text">
                              <p className="blue-txt mb-0 bs-lh">
                                Date/Time: {request.dateTime}
                              </p>
                              <p className="blue-txt mb-0 bs-lh">
                                Location: {request.location}
                              </p>
                              <p className="blue-txt mb-0 bs-lh">
                                Estimated Earnings: {request.earnings}
                              </p>
                            </div>
                            <a
                              href="#"
                              className="d-flex align-items-center ps-2 req-link"
                            >
                              <p className="blue-txt mb-0 pe-2 bs-lh">
                                Choose availability
                              </p>
                              {/* Button trigger modal */}
                              <div
                                className=""
                                data-bs-toggle="modal"
                                data-bs-target="#dateTime"
                              >
                                {request.id === 1 || request.id === 3 ? (
                                  <img
                                    src={request?.imageSrc}
                                    alt="calendar"
                                    className="pe-1 calendar-icon"
                                  />
                                ) : null}
                              </div>
                            </a>
                          </div>
                          <div className="ms-2 d-flex req-btns mt-3 mt-md-0 justify-content-end pad">
                            <a
                              href="#"
                              className="d-flex align-items-center px-3 py-4 blue-txt bg-white text-center"
                            >
                              Accept
                            </a>
                            <a
                              href="#"
                              className="d-flex align-items-center px-3 py-4 blue-txt bg-white text-center"
                            >
                              Deny
                            </a>
                          </div>
                        </div>
                      </div>
                    ))}
                    {/* ----------Request modal --------- */}

                    <div
                      className="modal fade"
                      id="dateTime"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            />
                          </div>
                          <div className="modal-body">
                            <h5 className="text-center p-2">
                              Select Date and Time
                            </h5>

                            <div>
                              <label className="p-2" htmlFor="time">
                                Date&Time
                              </label>
                              <input
                                className="form-control"
                                type="datetime-local"
                                name=""
                                id="time"
                              />
                            </div>

                            {/* <div>
                              <label className='p-2' htmlFor="time">Time</label>
                              <input className='form-control' type="time" name="" id="time" />
                              </div>
                              <div className='mt-3'>
                              <label className='p-2' htmlFor="date">Date</label>
                              <input className='form-control' type="date" name="" id="date" />
                              </div> */}
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-bs-dismiss="modal"
                            >
                              Close
                            </button>
                            <button type="button" className="btn btn-primary">
                              Save changes
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </section>
              {/*-----------------------------
                                  End || Payment section
                              ----------------------------- */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
